<template>
  <div :class="[showType == 'list' ? 'alarm-item-wrap list' : 'alarm-item-wrap']">
    <!-- 首页列表 -->
    <div v-if="showType == 'list'">
      <!-- 答题犹豫 -->
      <div class="left-alarm-event" v-if="messageItem.event === 'WARN_ANSWER_HESITATE'">
        <div class="left-alarm">
          <span class="alarm-type">{{messageItem.event | getEventName}}</span>
          <div v-for="(s,ind) in messageItem.question_ids" :key="`question_${ind}`">
            <a class="open-link" @click="viewQuestionDetail(s, ind, 'WARN_ANSWER_HESITATE', messageItem)">{{ $t('components.alarmItem.388300-0') }}</a>
            <span v-if="messageItem.cost_time">（{{messageItem.cost_time | formatTime}}）</span>
            <!-- <span class="line"></span> -->
          </div>
          <span class="module-name" v-if="messageItem.module_name">【{{ getModuleName(messageItem.module_name) }}】</span>
          <span class="module-name" v-if="messageItem.topic_sname">{{messageItem.topic_sname}}</span>
        </div>
        <span class="time">{{messageItem.c_time | timeago(timeNow)}}</span>
      </div>
      <!-- 视频报警 -->
      <div class="left-alarm-event" v-if="messageItem.event === 'WARN_VIDEO_UNPLAYED_SKIP' || messageItem.event === 'WARN_VIDEO_PLAYED_SKIP' || messageItem.event ==='WARN_VIDEO_END_DAZE' || messageItem.event ==='WARN_VIDEO_PAUSE_DAZE'">
        <div class="left-alarm">
          <span class="alarm-type">{{messageItem.event | getEventName}}</span>
          <a class="open-link" @click="viewVideo(messageItem.video_url)">{{ messageItem.video_type | getVideoName}}{{ $t('components.alarmItem.388300-1') }}</a>
          <span v-if="messageItem.video_duration > 0 ">（{{messageItem.video_duration | formatTime(item.user_agent,'video')}}）</span>
          <span class="line"></span>
          <span class="module-name" v-if="messageItem.module_name">【{{ getModuleName(messageItem.module_name) }}】</span>
          <span class="module-name" v-if="messageItem.tag_sname">{{messageItem.tag_sname}}</span>
        </div>
        <span class="time">{{messageItem.c_time | timeago(timeNow)}}</span>
      </div>
      <!-- 连错三题 -->
      <div class="left-alarm-event" v-if="messageItem.event === 'WARN_WRONG_ANSWER'">
        <div class="left-alarm">
          <span class="alarm-type">{{messageItem.event | getEventName}}</span>
          <ul class="wrong-list-ul">
            <li v-for="(qid, i) in messageItem.wrong_list" :key="`question_id${i}`">
              <a class="open-link" @click="viewQuestionDetail(qid, i, 'WARN_WRONG_ANSWER', messageItem)">{{ $t('components.alarmItem.388300-0') }}{{i + 1}}</a>
              <span v-if="messageItem['wrong_list_answer'] && messageItem['wrong_list_answer'][i] && messageItem['wrong_list_answer'][i].cost_time">（{{messageItem['wrong_list_answer'][i].cost_time | formatTime}}）</span>
              <span class="line"></span>
            </li>
          </ul>
          <!-- <span class="module-name" v-if="messageItem.module_name">【{{messageItem.module_name}}】</span>
          <span class="module-name" v-if="messageItem.topic_sname">{{messageItem.topic_sname}}</span> -->
        </div>
        <span class="time">{{messageItem.c_time | timeago(timeNow)}}</span>
      </div>
      <!-- {{ $t('components.alarmItem.388300-49') }}-->
      <div class="left-alarm-event" v-if="messageItem.event === 'WARN_ANSWER_TOO_FAST'">
        <div class="left-alarm">
          <span class="alarm-type">{{messageItem.event | getEventName}}</span>
          <ul class="wrong-list-ul">
            <li v-for="(qid, i) in messageItem.q_list" :key="`question_id${i}`">
              <a class="open-link" @click="viewQuestionDetail(qid, i, 'WARN_ANSWER_TOO_FAST', messageItem)">{{ $t('components.alarmItem.388300-0') }}{{i + 1}}</a>
              <span class="detail" v-if="messageItem['q_list_answer'][i] && messageItem['q_list_answer'][i].cost_time">（{{messageItem['q_list_answer'][i].cost_time | formatTime}}）</span>
              <span class="line"></span>
            </li>
          </ul>
          <!-- <span class="module-name" v-if="messageItem.module_name">【{{messageItem.module_name}}】</span>
          <span class="module-name" v-if="messageItem.topic_sname">{{messageItem.topic_sname}}</span> -->
        </div>
        <span class="time">{{messageItem.c_time | timeago(timeNow)}}</span>
      </div>
      <!-- {{ $t('components.alarmItem.388300-48') }}-->
      <div class="left-alarm-event" v-if="messageItem.event === 'WARN_ANSWER_TOO_SLOW'">
        <div class="left-alarm">
          <span class="alarm-type">{{messageItem.event | getEventName}}</span>
          <a class="open-link" @click="viewQuestionDetail(messageItem.question_id, 0, 'WARN_ANSWER_TOO_SLOW', messageItem)">{{ $t('components.alarmItem.388300-0') }}1</a>
          <span v-if="messageItem.answer.cost_time">（{{messageItem.answer.cost_time | formatTime}}）</span>
          <!-- <span class="line"></span> -->
          <span class="module-name" v-if="messageItem.module_name">【{{ getModuleName(messageItem.module_name) }}】</span>
          <span class="module-name" v-if="messageItem.tag_sname">{{messageItem.tag_sname}}</span>
        </div>
        <span class="time">{{messageItem.c_time | timeago(timeNow)}}</span>
      </div>
    </div>


    <!--学生详情页、实时报警-->
    <ul class="alarm-ul" v-if="showType == 'realTimeAlarm'">
      <li class="alarm-item" v-for="(item , index) in newMessageListX" :key="index">
        <!-- 答题犹豫 -->
        <div class="alarm-item-event" v-if="item.event === 'WARN_ANSWER_HESITATE' || item.event === 'WARN_NO_ACTION'">
          <div class="event-info">
            <div class="event-type">
              <span class="type">{{item.event | getEventName}}</span>
            </div>
            <ul class="event-ul">
              <li class="event-li" v-for="(s,ind) in item.question_ids" :key="`question_${ind}`">
                <span class="question" @click="viewQuestionDetail(s, index, 'WARN_ANSWER_HESITATE', item)">{{ $t('components.alarmItem.388300-0') }}</span>
                <span class="detail" v-if="item.cost_time">（{{item.cost_time | formatTime}}）</span>
              </li>
              <li class="module-name">
                <span v-if="item.module_name">【{{ getModuleName(item.module_name) }}】</span>
                <span v-if="item.topic_sname">{{item.topic_sname}}</span>
              </li>
            </ul>
          </div>
          <span class="time">{{item.c_time | timeago(timeNow)}}</span>
        </div>
        <!-- 视频报警 -->
        <div class="alarm-item-event" v-if="item.event === 'WARN_VIDEO_UNPLAYED_SKIP' || item.event === 'WARN_VIDEO_PLAYED_SKIP' || item.event ==='WARN_VIDEO_END_DAZE' || item.event ==='WARN_VIDEO_PAUSE_DAZE'">
          <div class="event-info">
            <div class="event-type">
              <span class="type">{{item.event | getEventName}}</span>
            </div>
            <ul class="event-ul">
              <li class="event-li">
                <span class="question" @click="viewVideo(item.video_url)">{{ item.video_type | getVideoName}} {{ $t('components.alarmItem.388300-1') }}</span>
                <span class="detail" v-if="item.video_duration >0 ">（{{item.video_duration | formatTime(item.user_agent,'video')}}）</span>
              </li>
              <li class="module-name">
                <span v-if="item.module_name">【{{ getModuleName(item.module_name) }}】</span>
                <span v-if="item.tag_sname">{{item.tag_sname}}</span>
              </li>
            </ul>
          </div>
          <span class="time">{{item.c_time | timeago(timeNow)}}</span>
        </div>
        <!-- 连错三题 -->
        <div class="alarm-item-event" v-if="item.event === 'WARN_WRONG_ANSWER'">
          <div class="event-info">
            <div class="event-type">
              <span class="type">{{item.event | getEventName}}</span>
            </div>
            <ul class="event-ul">
              <li class="event-li" v-for="(qid, i) in item.wrong_list" :key="`question_id${i}`">
                <span class="question" @click="viewQuestionDetail(qid, i, 'WARN_WRONG_ANSWER', item)">{{ $t('components.alarmItem.388300-0') }}{{i + 1}}</span>
                <span class="detail" v-if="item['wrong_list_answer'] && item['wrong_list_answer'][i] && item['wrong_list_answer'][i].cost_time">（{{item['wrong_list_answer'][i].cost_time | formatTime}}）</span>
                <span class="line"></span>
              </li>
            </ul>
          </div>
          <span class="time">{{item.c_time | timeago(timeNow)}}</span>
        </div>
        <!-- {{ $t('components.alarmItem.388300-49') }} -->
        <div class="alarm-item-event" v-if="item.event === 'WARN_ANSWER_TOO_FAST'">
          <div class="event-info">
            <div class="event-type">
              <span class="type">{{item.event | getEventName}}</span>
            </div>
            <ul class="event-ul">
              <li class="event-li" v-for="(qid, i) in item.q_list" :key="`question_id${i}`">
                <span class="question" @click="viewQuestionDetail(qid, i, 'WARN_ANSWER_TOO_FAST', item)">{{ $t('components.alarmItem.388300-0') }}{{i + 1}}</span>
                <span class="detail" v-if="item['q_list_answer'][i] && item['q_list_answer'][i].cost_time">（{{item['q_list_answer'][i].cost_time | formatTime}}）</span>
                <span class="line"></span>
              </li>
              <!-- <li class="module-name long">
                <span v-if="item.module_name">【{{item.module_name}}】</span>
                <span v-if="item.topic_sname">{{item.topic_sname}}</span>
              </li> -->
            </ul>
          </div>
          <span class="time">{{item.c_time | timeago(timeNow)}}</span>
        </div>
        <!-- {{ $t('components.alarmItem.388300-48') }} -->
        <div class="alarm-item-event" v-if="item.event === 'WARN_ANSWER_TOO_SLOW'">
          <div class="event-info">
            <div class="event-type">
              <span class="type">{{item.event | getEventName}}</span>
            </div>
            <ul class="event-ul">
              <li class="event-li">
                <span class="question" @click="viewQuestionDetail(item.question_id, 0, 'WARN_ANSWER_TOO_SLOW', item)">{{ $t('components.alarmItem.388300-0') }}1</span>
                <span class="detail" v-if="item.answer.cost_time">（{{item.answer.cost_time | formatTime}}）</span>
              </li>
              <li class="module-name">
                <span v-if="item.module_name">【{{ getModuleName(item.module_name) }}】</span>
                <span v-if="item.tag_sname">{{item.tag_sname}}</span>
              </li>
            </ul>
          </div>
          <span class="time">{{item.c_time | timeago(timeNow)}}</span>
        </div>
      </li>
    </ul>
    <!--答题详情的弹框-->
    <div class="questionListbox">
      <el-dialog :lock-scroll="true" top="10vh" title="" width="84%" :visible.sync="dialogTableVisible" @close="hideAnswerDetail" :modal-append-to-body='false'>
        <QuestionDetail
          v-if="hackReset"
          :subject_id="currentQuestionInfo.subject_id"
          :account_id="currentQuestionInfo.account_id"
          :user_id="currentQuestionInfo.user_id"
          :question_id="question_id"
          :dataSource="1"
          :course_id="currentQuestionInfo.course_id"
          :Onequestiontype="Onequestiontype"
          :serialNum="currentQuestionInfo.serialNum"
          :learning_version="currentQuestionInfo.learning_version"
        />
      </el-dialog>
      <div class="leftbtn" v-show="showLeftBtn" @click="lastQuestion">
        <i class="el-collapse-item__arrow el-icon-arrow-left"></i>
        <div>{{ $t('components.alarmItem.388300-3') }}</div>
      </div>
      <div class="rightbtn" v-show="showRightBtn" @click="nextQuestion">
        <i class="el-collapse-item__arrow el-icon-arrow-right"></i>
        <div>{{ $t('components.alarmItem.388300-4') }}</div>
      </div>
    </div>
    <!--{{ $t('components.alarmItem.388300-5') }}-->
    <el-dialog :lock-scroll="true" top="10vh" :title="`${$t('components.alarmItem.388300-5')}`" width="900px" :visible.sync="videoDialogTableVisible" @close="closeVideo" :modal-append-to-body='false' >
      <Video v-if="videoDialogTableVisible" id="video_box" ref="player" :video_url="videoUrl" />
    </el-dialog>
  </div>
</template>
<script>
import { getKnowledgeInfoBatch } from '@/api/base';
import Video from '@/components/video';
import QuestionDetail from '@/components/questionDetail';
import i18n from '@/i18n'
import { mapGetters } from 'vuex';
export default {
  name: "alarmItem",
  data () {
    return {
      dialogTableVisible: false,
      hackReset: false,
      videoDialogTableVisible: false,
      showLeftBtn: false,
      showRightBtn: false,
      Onequestiontype: 0, // 每一行的题目类型
      question_id: '',
      timeNow: new Date().getTime(),
      changeCount:0,
      questionIdList: [],
      currentQuestionInfo: {
        subject_id: '',
        account_id: '',
        course_id: '',
        learning_version: '',
      },
      newMessageListX: [],
      currentViewIndex: '', // 当前正在查看的题目的索引
      wrongQuestionItem: [],
      language: 'zh',
    }
  },
  props: {
    showType: {
      type: String
    },
    newMessageList: {
      type: Array
    },
    messageItem: {
      type: Object
    },
    item: {
      type: Object
    }
  },
  computed: {
    ...mapGetters([
      'systemTime'
    ]),
  },
  watch: {
    newMessageList: {
      handler(newValue, oldValue) {
        this.newMessageListX = newValue;
      },
      //deep: true
    },
    systemTime(newVal,oldVal){
      this.changeCount += 1
      if(this.changeCount > 18){
        this.timeNow = newVal
        this.changeCount = 0
      }
    }
  },
  components: { QuestionDetail, Video },
  mounted() {
    this.newMessageListX = this.newMessageList;
    this.getKnowledgeList()
    this.language = sessionStorage.getItem('Select-language') || 'zh'
  },
  methods: {
    getModuleName (moduleName) {
      const lang = this.language
      if (lang === 'en') {
        if (moduleName === '测试') {
          return 'Test'
        }
        if (moduleName === '学习') {
          return 'Learning'
        }
        if (moduleName === '重学') {
          return 'Restudy'
        }
        if (moduleName === '补漏测') {
          return 'Knowledge gap assessment'
        }
        if (moduleName === '补漏学') {
          return 'Knowledge gap learning'
        }
        if (moduleName === '章节结束') {
          return 'Chapter ends'
        }
      }
      return moduleName
    },
    getKnowledgeList()
    {
      let knowledge_codes = []
      if (this.newMessageListX && this.newMessageListX.length > 0) {
        this.newMessageListX.forEach(item=>{
          if(item.tag_code)
          {
            knowledge_codes.push(item.tag_code)
          }

        })
        let postData={
        subject_id:this.newMessageListX[0].subject_id,
        course_id:this.newMessageListX[0].course_id,
        user_id:this.newMessageListX[0].user_id || '',
        course_version:this.newMessageListX[0].course_version,
        knowledge_codes:knowledge_codes.join(","),
      }
      getKnowledgeInfoBatch(postData).then(res => {
          if (res.code == 200) {
            let knowledgeList  = res.data
            let messageList = []
            this.newMessageListX.forEach((item,index) => {

              // messageItem.event === 'WARN_VIDEO_UNPLAYED_SKIP' || messageItem.event === 'WARN_VIDEO_PLAYED_SKIP'
              // || messageItem.event ==='WARN_VIDEO_END_DAZE' || messageItem.event ==='WARN_VIDEO_PAUSE_DAZE'"
              let videoEvent=['WARN_VIDEO_UNPLAYED_SKIP','WARN_VIDEO_PLAYED_SKIP','WARN_VIDEO_END_DAZE','WARN_VIDEO_PAUSE_DAZE']

              if(videoEvent.indexOf(item.event)!== -1)
              {
                  item.tag_sname = knowledgeList[item.tag_code]?.tag_name || ''
                //  let tag_sname = knowledgeList[item.tag_code].tag_name || ''
                //  this.$set(this.newMessageListX[index],'tag_sname',tag_sname)
              // messageList.push(item)
                // console.log(knowledgeList[item.tag_code],item,'item333')
              }
            });
          }
        })
      }
    },
    viewQuestionDetail (qid, index, type, item) {
      this.currentQuestionInfo['account_id'] = item.account_id;
      this.currentQuestionInfo['user_id'] = item.user_id;
      this.currentQuestionInfo['course_id'] = item.course_id;
      this.currentQuestionInfo['subject_id'] = item.subject_id;
      this.currentQuestionInfo['learning_version'] = item.learning_version;
      // this.currentQuestionInfo['question_id'] = index;
      this.question_id = qid;
      this.dialogTableVisible = true;
      this.hackReset = true;
      if (type == 'WARN_WRONG_ANSWER' || type == 'WARN_ANSWER_TOO_FAST') { // 连错n题，答题过快
        if (type == 'WARN_WRONG_ANSWER') {
          this.questionIdList = item['wrong_list'];
        } else if (type == 'WARN_ANSWER_TOO_FAST') {
          this.questionIdList = item['q_list'];
        }
        this.wrongQuestionItem = item;
        this.currentViewIndex = index;
        console.log('this.questionIdList==='+JSON.stringify(this.questionIdList))
        if (this.currentViewIndex == 0) {
          this.showLeftBtn = false;
          this.showRightBtn = true;
        } else if (this.currentViewIndex == (this.questionIdList.length - 1)) {
          this.showLeftBtn = true;
          this.showRightBtn = false;
        } else {
          this.showLeftBtn = true;
          this.showRightBtn = true;
        }
      }
    },
    hideAnswerDetail () {
      this.showLeftBtn = false;
      this.showRightBtn = false;
      this.hackReset = false;
    },
     // 上一题
    lastQuestion() {
      if (this.currentViewIndex > 0) {
        this.hackReset = false;
        this.serialNum = this.currentViewIndex;
        this.question_id = this.questionIdList[this.currentViewIndex - 1];
        this.currentViewIndex--;
        this.$nextTick(() => {
          this.hackReset = true
        })
      }

      if (this.currentViewIndex ==  0 ) {
        this.showLeftBtn = false;
        this.showRightBtn = true;
      } else {
        this.showLeftBtn = true;
        this.showRightBtn = true;
      }
    },
    // 下一题
    nextQuestion () {
      if (this.currentViewIndex < this.questionIdList.length - 1) {
        this.hackReset = false;
        this.serialNum = this.currentViewIndex;
        this.question_id = this.questionIdList[this.currentViewIndex + 1];
        console.log('this.question_id==='+this.question_id)
        this.currentViewIndex++;
        this.$nextTick(() => {
          this.hackReset = true
        })
      }

      if (this.currentViewIndex ==  (this.questionIdList.length - 1) ) {
        this.showLeftBtn = true;
        this.showRightBtn = false;
      } else {
        this.showLeftBtn = true;
        this.showRightBtn = true;
      }
    },
    viewVideo (url) {
      this.videoUrl = url;
      this.videoDialogTableVisible = true;
    },
    closeVideo () {
      this.videoDialogTableVisible = false;
    },
    filterMessageList(messageLis, user_id) {
      return messageLis.filter(item => {
        return item.user_id == user_id;
      })
    },
  },
  filters: {
    parseSpentTime(msd) {
      var time = parseFloat(msd)
      if (time !== null && time !== '') {
        // 当答题用时超过30分钟时，只显示30分钟
        if (time > 30 * 60) {
          time = 30 * 60
        }
        if (time > 60 && time < 60 * 60) {
          time = parseInt(time / 60.0) + i18n.t('components.alarmItem.388300-6') + parseInt(time % 60) + i18n.t('components.alarmItem.388300-7')
        } else if (time >= 60 * 60 && time < 60 * 60 * 24) {
          time = parseInt(time / 3600.0) + i18n.t('components.alarmItem.388300-8') + parseInt((parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60) + i18n.t('components.alarmItem.388300-6') +
            parseInt((parseFloat((parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60) -
              parseInt((parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60)) * 60) + i18n.t('components.alarmItem.388300-7')
        } else {
          if (isNaN(time)) {
            return i18n.t('components.alarmItem.388300-9')
          } else {
            if (time < 0) {
              time = 0
            }
            time = parseInt(time) + i18n.t('components.alarmItem.388300-7')
          }
        }
      }
      return time
    },
    getVideoName (videoType) {
      let typeStr = ''

      if (videoType == 'IMPORT') {
        typeStr = i18n.t('components.alarmItem.388300-10');
      } else if (videoType == 'KNOWLEDGE') {
        typeStr = i18n.t('components.alarmItem.388300-11');
      } else if (videoType == 'QTID') {
        typeStr = i18n.t('components.alarmItem.388300-12');
      } else if (videoType == 'ANALYZE') {
        typeStr = i18n.t('components.alarmItem.388300-13');
      } else if (videoType == 'ERRORCAUSE') {
        typeStr = i18n.t('components.alarmItem.388300-14');
      } else if (videoType == 'SKILL') {
        typeStr = i18n.t('components.alarmItem.388300-15');
      } else if (videoType == 'QUESTION') {
        typeStr = i18n.t('components.alarmItem.388300-16');
      }
      return typeStr;
    },
    // 卡片事件
    getEventName(val, videoType) {
      let eventName = ''
      let typeStr = ''

      if (videoType == 'IMPORT') {
        typeStr = i18n.t('components.alarmItem.388300-10');
      } else if (videoType == 'KNOWLEDGE') {
        typeStr = i18n.t('components.alarmItem.388300-11');
      } else if (videoType == 'QTID') {
        typeStr = i18n.t('components.alarmItem.388300-12');
      } else if (videoType == 'ANALYZE') {
        typeStr = i18n.t('components.alarmItem.388300-13');
      } else if (videoType == 'ERRORCAUSE') {
        typeStr = i18n.t('components.alarmItem.388300-14');
      } else if (videoType == 'SKILL') {
        typeStr = i18n.t('components.alarmItem.388300-15');
      } else if (videoType == 'QUESTION') {
        typeStr = i18n.t('components.alarmItem.388300-16');
      } else if (videoType == 'TAIL') {
        typeStr = i18n.t('components.alarmItem.388300-17');
      }

      switch (val) {
        case 'LOGIN':
          eventName = i18n.t('components.alarmItem.388300-18')
          break
        case 'RELOGIN':
          eventName = i18n.t('components.alarmItem.388300-19')
          break
        case 'MODULE_START':
          eventName = i18n.t('components.alarmItem.388300-20')
          break
        case 'GET_QUESTION':
          if (val.hasOwnProperty('question_round')) {
            if (val.question_round == 1) {
              eventName = i18n.t('components.alarmItem.388300-21')
            } else if (val.question_round == 2) {
              eventName = i18n.t('components.alarmItem.388300-22')
            }
          } else {
            eventName = i18n.t('components.alarmItem.388300-23')
          }
          break
        case 'SUBMIT_ANSWER':
          eventName = val.flow_id == 1000 ? '考试结束' : i18n.t('components.alarmItem.388300-24')
          break
        case 'GET_ANALYSIS':
          if (val.hasOwnProperty('question_round')) {
            if (val.question_round == 1) {
              eventName = i18n.t('components.alarmItem.388300-25')
            } else if (val.question_round == 2) {
              eventName = i18n.t('components.alarmItem.388300-26')
            }
          } else {
            eventName = i18n.t('components.alarmItem.388300-27')
          }
          break
        case 'GET_QLIST':
          eventName = i18n.t('components.alarmItem.388300-28')
          break
        case 'GET_REPORT':
          eventName = i18n.t('components.alarmItem.388300-29')
          break
        case 'VIDEO_PLAY':
          console.log('videoType='+videoType)
          eventName = i18n.t('components.alarmItem.388300-30') + typeStr + i18n.t('components.alarmItem.388300-1')
          break
        case 'VIDEO_CLOSE':
          eventName = i18n.t('components.alarmItem.388300-31') + typeStr + i18n.t('components.alarmItem.388300-1')
          break
        case 'VIDEO_END':
          eventName = i18n.t('components.alarmItem.388300-32')
          break
        case 'VIDEO_PAUSE':
          eventName = i18n.t('components.alarmItem.388300-33') + typeStr + i18n.t('components.alarmItem.388300-1')
          break
        case 'VIDEO_DRAG':
          eventName = i18n.t('components.alarmItem.388300-34') + typeStr + i18n.t('components.alarmItem.388300-1')
          break
        case 'VIDEO_BACK':
          eventName = i18n.t('components.alarmItem.388300-35') + typeStr + i18n.t('components.alarmItem.388300-1')
          break
        case 'VIDEO_SKIP':
          eventName = i18n.t('components.alarmItem.388300-36') + typeStr + i18n.t('components.alarmItem.388300-1')
          break
        case 'VIDEO_END_DAZE':
          eventName = i18n.t('components.alarmItem.388300-37')
          break
        case 'VIDEO_PAUSE_DAZE':
          eventName = i18n.t('components.alarmItem.388300-38')
          break
        case 'VIDEO_UNPLAYED_SKIP':
          eventName = i18n.t('components.alarmItem.388300-39')
          break
        case 'NO_ACTION':
          eventName = i18n.t('components.alarmItem.388300-40')
          break
        case 'WARN_VIDEO_UNPLAYED_SKIP':
          eventName = i18n.t('components.alarmItem.388300-41')
          break
        case 'WARN_VIDEO_PLAYED_SKIP':
          eventName = i18n.t('components.alarmItem.388300-42')
          break
        case 'WARN_VIDEO_PAUSE_DAZE':
          eventName = i18n.t('components.alarmItem.388300-38')
          break
        case 'WARN_VIDEO_END_DAZE':
          eventName = i18n.t('components.alarmItem.388300-37')
          break
        case 'WARN_NO_ACTION':
          eventName = i18n.t('components.alarmItem.388300-43')
          break
        case 'ANSWER_HESITATE':
          eventName = i18n.t('components.alarmItem.388300-44')
          break
        case 'WARN_ANSWER_HESITATE':
          eventName = i18n.t('components.alarmItem.388300-44')
          break
        // case 'WARN_MODULE_END':
        //   eventName = '模块完成报警'
        //   break
        case 'WARN_WRONG_ANSWER':
          eventName = i18n.t('components.alarmItem.388300-45')
          break
        case 'MODULE_END':
          eventName = i18n.t('components.alarmItem.388300-46')
          break
        case 'TAG_CODE_END':
          eventName = i18n.t('components.alarmItem.388300-47')
          break
        case 'WARN_ANSWER_TOO_SLOW':
          eventName = i18n.t('components.alarmItem.388300-48')
          break
        case 'WARN_ANSWER_TOO_FAST':
          eventName = i18n.t('components.alarmItem.388300-49')
          break
        default:
          eventName = i18n.t('components.alarmItem.388300-9')
      }
      return eventName
    },
    timeago(dateTimeStamp,time1){
      var minute = 1000 * 60;      //把分，时，天，周，半个月，一个月用毫秒表示
      var hour = minute * 60;
      var day = hour * 24;
      var week = day * 7;
      var halfamonth = day * 15;
      var month = day * 30;
      var now = new Date().getTime();   //获取当前时间毫秒
      // console.log(now)
      var diffValue = now - dateTimeStamp;//时间差
      var isShowDay = false;
      var currentDayZero = new Date();
      var currentDayZeroYear = currentDayZero.getFullYear();
      var currentDayZeroMonth = currentDayZero.getMonth() + 1;
      var currentDayZeroDate = currentDayZero.getDate();

      var dayZero = new Date(`${currentDayZeroYear}/${currentDayZeroMonth}/${currentDayZeroDate} 00:00:00`).getTime();
      if (dateTimeStamp < dayZero) {
        isShowDay = true;
      }

      if(diffValue < 0){
        return;
      }
      var result = '';
      var minC = diffValue/minute;  //计算时间差的分，时，天，周，月
      var hourC = diffValue/hour;
      var dayC = diffValue/day;
      var weekC = diffValue/week;
      var monthC = diffValue/month;

      if (minC >= 1 && minC <= 10) {
        result =" " + parseInt(minC) + i18n.t('components.alarmItem.388300-50')
      } else {
        var datetime = new Date();
        datetime.setTime(dateTimeStamp);
        var Nyear = datetime.getFullYear();
        var Nmonth = datetime.getMonth() + 1 < 10 ? "0" + (datetime.getMonth() + 1) : datetime.getMonth() + 1;
        var Ndate = datetime.getDate() < 10 ? "0" + datetime.getDate() : datetime.getDate();
        var Nhour = datetime.getHours() < 10 ? "0" + datetime.getHours() : datetime.getHours();
        var Nminute = datetime.getMinutes() < 10 ? "0" + datetime.getMinutes() : datetime.getMinutes();
        var Nsecond = datetime.getSeconds() < 10 ? "0" + datetime.getSeconds() : datetime.getSeconds();
        if (isShowDay) {
          result = Nmonth + '-' + Ndate + ' ' + Nhour + ":" + Nminute + ":" + Nsecond
        } else {
          result = Nhour + ":" + Nminute + ":" + Nsecond
        }
      }

      // if(monthC >= 1 && monthC <= 3){
      //   result = " " + parseInt(monthC) + "月前"
      // }else if(weekC >= 1 && weekC <= 3){
      //   result = " " + parseInt(weekC) + "周前"
      // }else if(dayC >= 1 && dayC <= 6){
      //   result = " " + parseInt(dayC) + "天前"
      // }else if(hourC >= 1 && hourC <= 23){
      //   result = " " + parseInt(hourC) + "小时前"
      // }else if(minC >= 1 && minC <= 10){
      //   result =" " + parseInt(minC) + i18n.t('components.alarmItem.388300-50')
      // }else if(diffValue >= 0 && diffValue <= minute){
      //   result = "刚刚"
      // }else {
      //   var datetime = new Date();
      //   datetime.setTime(dateTimeStamp);
      //   var Nyear = datetime.getFullYear();
      //   var Nmonth = datetime.getMonth() + 1 < 10 ? "0" + (datetime.getMonth() + 1) : datetime.getMonth() + 1;
      //   var Ndate = datetime.getDate() < 10 ? "0" + datetime.getDate() : datetime.getDate();
      //   var Nhour = datetime.getHours() < 10 ? "0" + datetime.getHours() : datetime.getHours();
      //   var Nminute = datetime.getMinutes() < 10 ? "0" + datetime.getMinutes() : datetime.getMinutes();
      //   var Nsecond = datetime.getSeconds() < 10 ? "0" + datetime.getSeconds() : datetime.getSeconds();
      //   result = Nyear + "-" + Nmonth + "-" + Ndate
      // }
      return result;
    },
    formatTime (s,from='',type="") {
      if(s<0)
      {
        return ''
      }

      if(from.indexOf('SSAI_Android')>0 && type=="video")
      {
        s = parseInt(s/1000) // 如果是pad端的视频，则转化成秒
      }

      let result = '';
      if (s == 0) {
        result = i18n.t('components.alarmItem.388300-51');
      } else {
        var day = Math.floor( s/ (24*3600) ); // Math.floor()向下取整
        var hour = Math.floor( (s - day*24*3600) / 3600);
        var minute = Math.floor( (s - day*24*3600 - hour*3600) /60 );
        var second = s - day*24*3600 - hour*3600 - minute*60;
        second = Math.floor(second);

        if (day > 0) {
          result = i18n.t('components.alarmItem.388300-52', [day])
        }

        if (hour > 0) {
          result += i18n.t('components.alarmItem.388300-53', [hour])
        }

        if (minute > 0) {
          result += i18n.t('components.alarmItem.388300-54', [minute])
        }

        if (second > 0) {
          result += i18n.t('components.alarmItem.388300-55', [second])
        }
      }
      // return day + "天"  + hour + "时" + minute + "分" + second + i18n.t('components.alarmItem.388300-7');
      return result;
    },
  }
}
</script>
<style scoped lang="scss">
.alarm-ul {
    max-height: 440px;
    .alarm-item {
      position: relative;
      overflow: hidden;
      margin-bottom: 23px;
      .alarm-item-event {
        display: flex;
        align-items: baseline;
        justify-content: space-between;
        .event-info {
          display: flex;
        }
      }
      .event-type {
        // float: left;
        margin-right: 10px;
        .type {
          padding: 0 6px;
          // height: 20px;
          background: #FFEFEF;
          border-radius: 4px;
          font-size: 12px;
          color: #FF4757;
          font-weight: 500;
          border: 1px solid #FF4757;
          display: inline-block;
          line-height: 20px;
        }
      }
      .event-ul {
        flex-direction: row;
        flex-wrap: wrap;
        max-width: 520px;
        color: #858A9B;
        display: flex;
        align-items: center;
        li {
          // float: left;
          font-size: 14px;
          margin-right: 6px;
          .question {
            font-weight: 400;
            color: #207CFF;
            text-decoration: underline;
            &:hover {
              cursor: pointer;
            }
          }
          .line {
            width: 1px;
            height: 14px;
            color: #D3D8E8;
            background-color: #D3D8E8;
            display: inline-block;
            vertical-align: middle;
          }
          .detail {
            font-weight: 400;
            font-size: 14px;
            color: #858A9B;
          }
          &.module-name {
            max-width: 300px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-weight: 400;
            &.long {
              width: 100px;
            }
          }
          &:last-child {
            .line {
              display: none;
            }
          }
        }
      }
      .time {
        // position: absolute;
        width: 120px;
        height: 17px;
        margin-left: 24px;
        // top: 3px;
        // right: 0;
        font-size: 12px;
        color: #A7B2D2;
      }
    }
  }
  .leftbtn{
    width:72px;
    height:100px;
    -webkit-border-radius:0 4px 4px 0;
    -moz-border-radius:0 4px 4px 0;
    border-radius:0 4px 4px 0;
    position: fixed;
    left:0;
    top:50%;
    margin-top:-50px;
    z-index:9999;
    font-size:16px;
    color:rgba(68,75,101,1);
    line-height:22px;
    text-align: center;
    cursor: pointer;
    background:rgba(255,255,255,0.5);
    .el-collapse-item__arrow{
      margin:24px auto 10px;
      color: #696F84;
    }
    &:hover{
      background:rgba(255,255,255,1);
    }
  }
  .rightbtn{
    width:72px;
    height:100px;
    cursor: pointer;
    border-radius:4px 0 0 4px;
    position: fixed;
    right:0;
    top:50%;
    margin-top:-50px;
    z-index:9999;
    font-size:16px;
    color:rgba(68,75,101,1);
    line-height:22px;
    text-align: center;
    background:rgba(255,255,255,0.5);
    .el-icon-arrow-right{
      margin:24px auto 10px;
      color: #696F84;
    }
    &:hover{
      background:rgba(255,255,255,1);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/alarmItem.vue